import PropTypes from 'prop-types';

const GlobalSecondarySubNav = ({ children }) => (
  <div className="global-secondary-subnavigation">{children}</div>
);

GlobalSecondarySubNav.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalSecondarySubNav;
